import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import LoadingSpinner from './loading-spinner';
import Glow from '../keyframes';

const Disabled = css`
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.3;
`;

const BaseStyled = styled.button`
  background-image: none;
  border: 1px solid transparent;
  border-radius: 0;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.25;
  margin-bottom: 0;
  padding: 6px 12px;
  text-align: center;
  touch-action: manipulation;
  user-select: none;
  vertical-align: middle;
  white-space: nowrap;

  background-color: ${props => props.color || props.theme.carvana.blue};
  color: #fff;
  font-size: 16px;
  margin-left: auto;
  margin-right: auto;
  min-height: 4rem;
  min-width: 15rem;
  padding: 10px;
  text-transform: uppercase;
  width: ${props => (props.width ? `calc(${props.width} - 4rem)` : '100%')};
  overflow: visible;

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    width: ${props => props.width || '100%'};
    font-size: 19px;
  }

  & :focus {
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }

  ${props => props.glow && Glow(props.theme.carvana[props.glow])}

  ${props => props.disabled && Disabled}
`;

const Base = ({ children, isBusy, ...rest }) => (
  <Fragment>
    <BaseStyled {...rest}>
      {isBusy && <LoadingSpinner />}
      {children}
    </BaseStyled>
  </Fragment>
);

Base.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType])
    .isRequired,
  isBusy: PropTypes.bool
};

Base.defaultProps = {
  isBusy: false
};

export default Base;
